import React, { useState, useEffect } from "react";
import "../App.css";
import HeroSection from "../components/HeroSection";
import LazyLoad from "react-lazy-load";
import Footer from "../components/Footer";
import CenterMedia from "../components/CenterMedia";
import FullWidthMedia from "../components/FullWidthMedia";
import ThreeColumns from "../components/ThreeColumns";
import Gap from "../components/Gap";

function Videos() {
  const [hasUserInteracted, setHasUserInteracted] = useState(false);

  useEffect(() => {
    const handleUserInteraction = () => {
      setHasUserInteracted(true);
    };

    document.addEventListener("click", handleUserInteraction);
    document.addEventListener("keydown", handleUserInteraction);
    document.addEventListener("scroll", handleUserInteraction);

    return () => {
      document.removeEventListener("click", handleUserInteraction);
      document.removeEventListener("keydown", handleUserInteraction);
      document.removeEventListener("scroll", handleUserInteraction);
    };
  }, []);

  return (
    <>
      <HeroSection
        media={{
          type: "video",
          src: "../Videos/Banner/birra-bin-border.mp4",
        }}
      />
      <Gap />
      <div className="container">
        <LazyLoad preload offset={1000} once>
          <ThreeColumns
            layout="three-equal"
            mediaList={[
              {
                type: "video",
                src: "../Videos/vw-india/Gifts & diapers.mp4",
                column: "left",
              },
              {
                type: "image",
                src: "../logos-and-png-text/vw2.webp",
                column: "center",
                width: "35%",
                height: "auto",
                verticalAlign: "flex-end",
              },
              {
                type: "image",
                src: "../logos-and-png-text/vw1.png",
                column: "center",
                width: "60%",
                height: "auto",
                verticalAlign: "center",
              },
              {
                type: "video",
                src: "../Videos/vw-india/VW park assist.mp4",
                column: "right",
              },
            ]}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={300} once>
          <div className="padding-10">
            <ThreeColumns
              layout="three-equal"
              mediaList={[
                { type: "video", src: "../Home/lake-district/buttermere.mp4" },
                {
                  type: "video",
                  src: "../Home/lake-district/coffee-cup.mp4",
                },
                {
                  type: "video",
                  src: "../Home/lake-district/kabhie-kabhie.mp4",
                },
              ]}
              userInteracted={hasUserInteracted}
            />
          </div>
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/chaayos/Chaayos-masala-chai.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        {/* <Gap />

        <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{
              src: "../Videos/delhi-6/delhi 6.MP4",
              type: "video",
            }}
            column="center"
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        {/* <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/uk-snippets-travel/TFL.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ThreeColumns
            layout="three-equal"
            mediaList={[
              {
                type: "video",
                src: "../Videos/uk-snippets-travel/st. paul's.mp4",
              },
              {
                type: "video",
                src: "../Videos/uk-snippets-travel/money money.mp4",
              },
              {
                type: "video",
                src: "../Videos/uk-snippets-travel/kenwood house.mp4",
              },
            ]}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/word-on-water/bookstore.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        {/* <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/Suzuki/Limitless.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ThreeColumns
            layout="three-equal"
            mediaList={[
              {
                type: "video",
                src: "../Videos/Suzuki/Suzuki-making-memories-again.mp4",
                column: "left",
              },
              {
                type: "image",
                src: "../logos-and-png-text/suzuki.svg",
                column: "center",
                width: "50%",
                height: "auto",
                verticalAlign: "center",
              },
              {
                type: "video",
                src: "../Videos/Suzuki/Thrill-makers-Nexa.mp4",
                column: "right",
              },
            ]}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/lavans/24fps.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <CenterMedia
            media={{
              src: "../Videos/lavans/lavans-bebi.MP4",
              type: "video",
            }}
            column="center"
            responsivePadding={true}
            maxPadding={500}
            disablePaddingOnMobile={true}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/trisara/trailer.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <div className="padding-100">
            <ThreeColumns
              layout="three-equal"
              mediaList={[
                {
                  type: "video",
                  src: "../Videos/rajasthan-tourism/jaipur.mp4",
                  column: "left",
                },
                {
                  type: "image",
                  src: "../logos-and-png-text/rajasthan copy.webp",
                  column: "center",
                  width: "50%",
                  height: "auto",
                  verticalAlign: "center",
                },
                {
                  type: "video",
                  src: "../Videos/rajasthan-tourism/rel 2.mp4",
                  column: "right",
                  width: "94.6%",
                  height: "auto",
                  position: "right",
                },
              ]}
              userInteracted={hasUserInteracted}
            />
          </div>
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={300} once>
          <FullWidthMedia
            media={{
              src: "../Home/Fish-and-chips/Fish-and-chips-fianl-review-v2-hq.mp4.mov",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        {/* <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/a&r-by-rhea/velvets.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad> */}

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ThreeColumns
            layout="three-equal"
            mediaList={[
              {
                type: "video",
                src: "../Videos/house-of-alams/kheliye dhamaal/first duo.mp4",
              },
              {
                type: "video",
                src: "../Videos/house-of-alams/kheliye dhamaal/khwaja sang kheliye.mp4",
              },
              {
                type: "video",
                src: "../Videos/house-of-alams/kheliye dhamaal/last duo ek suratiya.mp4",
              },
            ]}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/uk-snippets-travel/aaj jaunga.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <ThreeColumns
            layout="three-equal"
            mediaList={[
              {
                type: "video",
                src: "../Videos/torani/tp1.mp4",
                column: "left",
              },
              {
                type: "image",
                src: "../logos-and-png-text/torani.webp",
                column: "center",
                width: "50%",
                height: "auto",
                verticalAlign: "center",
              },
              {
                type: "video",
                src: "../Videos/torani/tp2.mp4",
                column: "right",
              },
            ]}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/akshath/Khoyaaaa-yt.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <div className="whitebg">
            <ThreeColumns
              layout="three-equal"
              mediaList={[
                {
                  type: "video",
                  src: "../Videos/mulmul/mulmul-bts-2.mp4",
                },
                {
                  type: "video",
                  src: "../Videos/mulmul/rishikesh-bts.mp4",
                },
                {
                  type: "video",
                  src: "../Videos/mulmul/mulmul-post.mp4",
                },
              ]}
              userInteracted={hasUserInteracted}
            />
          </div>
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <FullWidthMedia
            media={{
              src: "../Videos/uk-snippets-travel/tower bridge.mp4",
              type: "video",
            }}
            userInteracted={hasUserInteracted}
          />
        </LazyLoad>

        <Gap />

        <LazyLoad preload offset={1000} once>
          <div className="fit-screen">
            <CenterMedia
              media={{
                src: "../Videos/weezy/this-video-needs-a-text-in-the-end.mp4",
                type: "video",
              }}
              column="center"
              responsivePadding={true}
              maxPadding={300}
              disablePaddingOnMobile={true}
              userInteracted={hasUserInteracted}
            />
          </div>
        </LazyLoad>
      </div>
      <Footer />
    </>
  );
}

export default Videos;
